import { ArrowLeft, ArrowRight } from "lucide-react";

type PostLink = {
  href: string;
  title: string;
};

type BlogPostNavigationProps = {
  newer: PostLink | null;
  older: PostLink | null;
  newerLabel: string;
  olderLabel: string;
  ariaLabel: string;
};

export function BlogPostNavigation({
  newer,
  older,
  newerLabel,
  olderLabel,
  ariaLabel,
}: BlogPostNavigationProps) {
  if (!newer && !older) return null;

  const linkClassName =
    "group flex min-h-28 flex-col justify-center rounded-2xl border border-border/70 bg-card/70 p-4 transition-[border-color,background-color,box-shadow] hover:border-primary/30 hover:bg-accent/50 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:p-5";

  return (
    <nav aria-label={ariaLabel} className="mt-14 border-y border-border/70 py-5 sm:py-6">
      <div className="grid gap-3 sm:grid-cols-2">
        {newer && (
          <a href={newer.href} className={linkClassName} rel="prev">
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary">
              <ArrowLeft
                aria-hidden
                className="h-4 w-4 transition-transform group-hover:-translate-x-0.5"
              />
              {newerLabel}
            </span>
            <span className="mt-2 line-clamp-2 font-semibold leading-snug text-foreground">
              {newer.title}
            </span>
          </a>
        )}

        {older && (
          <a
            href={older.href}
            className={`${linkClassName} items-end text-right sm:col-start-2`}
            rel="next"
          >
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary">
              {olderLabel}
              <ArrowRight
                aria-hidden
                className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              />
            </span>
            <span className="mt-2 line-clamp-2 font-semibold leading-snug text-foreground">
              {older.title}
            </span>
          </a>
        )}
      </div>
    </nav>
  );
}
